import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, BookOpen, FileText, FlaskConical, Users, ClipboardCheck, ListChecks } from 'lucide-react';
const modules = [{
  icon: Calendar,
  title: '1) Planificación anual + programa por unidades',
  desc: 'Para que no inventes el año semana a semana.',
  items: ['Planificación anual sugerida', 'Objetivos por período', 'Secuencia por unidades', 'Plantilla semanal simple y detallada', 'Checklist docente para planificar en minutos']
}, {
  icon: BookOpen,
  title: '2) Unidades listas (Biología, Física y Química básica)',
  desc: 'Contenido organizado por temas clave, con progresión real.',
  items: ['🧬 Biología: Células, sistemas, reproducción, ecosistemas', '⚡ Física: Fuerza, energía, calor, luz, electricidad básica', '🧪 Química: Materia, mezclas, ácidos y bases, reacciones']
}, {
  icon: FileText,
  title: '3) Guías imprimibles listas para aula',
  desc: 'Claras y aplicables.',
  items: ['Explicación simple y directa', 'Actividades graduales (base / intermedio / desafío)', 'Ejercicios aplicados a la vida real', 'Fichas visuales para entender sin confusión']
}, {
  icon: FlaskConical,
  title: '4) Experimentos y prácticas simples',
  desc: 'Sin laboratorio. Clave para que Ciencias se sienta “real”.',
  items: ['Prácticas fáciles con materiales comunes', 'Experimentos seguros y observaciones guiadas', 'Registro de resultados y plantillas de informe', 'Variantes si no tenés materiales']
}, {
  icon: Users,
  title: '5) Actividades dinámicas para participación',
  desc: 'Para evitar la típica clase donde “solo copian”.',
  items: ['Actividades en equipo y estaciones de trabajo', 'Desafíos científicos y juegos de repaso', 'Tarjetas de preguntas', 'Dinámicas para energía alta / energía baja']
}, {
  icon: ClipboardCheck,
  title: '6) Evaluaciones listas + pautas',
  desc: 'Evaluar Ciencias no tiene por qué llevarte una tarde.',
  items: ['Evaluaciones por unidad', 'Versiones adaptables por nivel', 'Preguntas aplicadas y pauta o clave orientativa', 'Pruebas cortas tipo “exit ticket” (5 min)']
}, {
  icon: ListChecks,
  title: '7) Rúbricas y listas de cotejo',
  desc: 'Para evaluar de forma más clara y objetiva.',
  items: ['Rúbrica para informes y proyectos', 'Lista de cotejo para prácticas', 'Participación y trabajo en equipo', 'Autoevaluación del estudiante']
}];
export const ProductBreakdown: React.FC = () => {
  return <section className="py-20 bg-white" data-id="element-124">
      <div className="container mx-auto px-4" data-id="element-125">
        <div className="text-center mb-16" data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-127">
            MegaPack Ciencias Naturales Lista (qué incluye)
          </h2>
          <p className="text-xl text-gray-600" data-id="element-128">
            Todo el contenido está organizado por unidades, con material
            imprimible y guías claras.
          </p>
        </div>

        <div className="space-y-8 max-w-4xl mx-auto" data-id="element-129">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5
        }} className="flex flex-col md:flex-row gap-6 bg-stone-50 p-6 md:p-8 rounded-2xl border border-stone-200 hover:border-green-300 transition-colors" data-id="element-130">
              <div className="flex-shrink-0" data-id="element-131">
                <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center text-green-700" data-id="element-132">
                  <module.icon className="w-8 h-8" data-id="element-133" />
                </div>
              </div>

              <div className="flex-1" data-id="element-134">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-135">
                  {module.title}
                </h3>
                <p className="text-gray-600 mb-4 font-medium" data-id="element-136">{module.desc}</p>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2" data-id="element-137">
                  {module.items.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-138">
                      <span className="w-1.5 h-1.5 bg-green-500 rounded-full mt-1.5 flex-shrink-0" data-id="element-139"></span>
                      <span data-id="element-140">{item}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};